import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../../SidebarContext';
import Sidebar from '../SideBar';
import MarqueeModal from './MarqueeModal';


const Marquee = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    const [amenities, setAmenities] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [inputValue, setInputValue] = useState('');
    const [inputValuelink, setInputValuelink] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [marquee, setMarquee] = useState({
        heading: "",
        sub_heading: "",
        type: "Always",
        date: "",
        link: "",
        status: "",
        user_id: isLoggedIn.user_id,
    })

    const itemsPerPage = 10;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const url=process.env.REACT_APP_LINK

    const BASE_URL = `${url}`;

    useEffect(() => {
        fetchAmenities();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/marquee/all/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleTypeChange = (selectedOption) => {
        setMarquee(prevData => ({
            ...prevData,
            type: selectedOption ? selectedOption.value : ""
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setMarquee(prevData => ({
            ...prevData,
            status: selectedOption ? selectedOption.value : ""
        }));
    };

    const TypeOptions = [
        { value: 'End Date', label: 'End Date' },
        { value: 'Always', label: 'Always' },
    ];
    const filteredAmenities = amenities.filter((item) =>
        ['name', 'status'].some((key) =>
            String(item[key]).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalPages = Math.ceil(filteredAmenities.length / itemsPerPage);
    const currentData = filteredAmenities.slice(indexOfFirstItem, indexOfFirstItem + itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // const handleInputChange = (event) => setInputValue(event.target.value);
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Restrict heading and sub_heading to 40 characters
        if (name === "heading" && value.length > 60) return;
        if (name === "sub_heading" && value.length > 100) return;

        setMarquee(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleInputChangeLink = (event) => setInputValuelink(event.target.value);
    const handleFileChange = (event) => setSelectedFile(event.target.files[0]);

    const handleAddAmenities = async () => {
        try {
            const response = await fetch(`${BASE_URL}/marquee`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(marquee)
            });
            const res = await response.json();
            console.log(res);

            if (res && res.message) {
                toast.success("Text Ad Added Successfully");
                setIsModalOpen(false);
                setMarquee({
                    id: "",
                    heading: "",
                    sub_heading: "",
                    type: "",
                    date: "",
                    link: "",
                    status: "",
                    user_id: isLoggedIn.user_id,
                });
                fetchAmenities();
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to add Text Ad");
        }
    };


    const handleEdit = (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const selectedMarquee = amenities[absoluteIndex];

        setMarquee({
            id: selectedMarquee.id,
            heading: selectedMarquee.heading,
            sub_heading: selectedMarquee.sub_heading,
            type: selectedMarquee.type,
            date: selectedMarquee.date,
            link: selectedMarquee.link,
            status: selectedMarquee.status,
            user_id: isLoggedIn.user_id,
        });

        setIsModalOpen(true);
    };


    const handleEditChange = (event) => {
        setEditValue(event.target.value);
    };

    const handleUpdateAmenities = async () => {
        try {
            const response = await fetch(`${BASE_URL}/marquee/change/${marquee.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(marquee)
            });
            const res = await response.json();
            console.log(res);

            if (res && res.message) {
                toast.success("Text Ad Updated Successfully");
                setIsModalOpen(false);
                fetchAmenities();
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to update marquee");
        }
    };


    const handleDelete = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        try {
            const response = await axios.delete(`${BASE_URL}/marquee/${amenity.id}`);
            if (response.status === 200) {
                toast.success('Text Ad Deleted');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error deleting location:', error);
        }
    };

    const handleToggleStatus = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        const updatedStatus = amenity.status === 'Active' ? 'Inactive' : 'Active';

        try {
            const response = await axios.put(`${BASE_URL}/marquee/change/${amenity.id}`, { status: updatedStatus });
            if (response.status === 200) {
                toast.success('Text Ad Status Updated');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error toggling status:', error);
        }
    };

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];
    console.log(marquee)
    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Text Ads</h1>
                    <button
                        className="oms-add-btn"
                        onClick={() => {
                            setMarquee({
                                heading: "",
                                sub_heading: "",
                                type: "Always",
                                date: "",
                                link: "",
                                status: "",
                                user_id: isLoggedIn.user_id,
                            });
                            setIsModalOpen(true);
                        }}
                    >
                        Add Text Ads
                    </button>

                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Heading</th>
                                <th>SubHeading</th>
                                <th>Type</th>
                                <th>
                                    Link
                                </th>
                                <th>Date</th>

                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData && currentData.length > 0 ? (
                                currentData.map((amenity, index) => {
                                    const absoluteIndex = indexOfFirstItem + index;
                                    return (
                                        <tr key={amenity.id}>
                                            <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {amenity.heading}
                                            </td>
                                            <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {amenity.sub_heading}
                                            </td>
                                            <td>
                                                {
                                                    amenity.type
                                                }
                                            </td>
                                            <td>
                                                {
                                                    amenity.link
                                                }
                                            </td>
                                            <td>
                                                {
                                                    amenity.date || "-"
                                                }
                                            </td>
                                            <td>
                                                <span className={amenity.status}>
                                                    {amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}
                                                </span>
                                            </td>
                                            <td>
                                                <button onClick={() => handleToggleStatus(index)}>
                                                    <i className={`fa ${amenity.status === 'Active' ? 'fa-toggle-on' : 'fa-toggle-off'}`} />
                                                </button>


                                                <button onClick={() => handleEdit(index)}>
                                                    <i className="fa fa-edit" />
                                                </button>


                                                <button onClick={() => handleDelete(index)}>
                                                    <i className="fa fa-trash" />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="3">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <MarqueeModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                marquee={marquee}
                handleInputChange={handleInputChange}
                inputValuelink={inputValuelink}
                handleInputChangeLink={handleInputChangeLink}
                handleFileChange={handleFileChange}
                handleAddAmenities={handleAddAmenities}
                handleStatusChange={handleStatusChange}
                handleTypeChange={handleTypeChange}
                TypeOptions={TypeOptions}
                statusOptions={statusOptions}
                handleUpdateAmenities={handleUpdateAmenities}
            />
        </>
    );
};

export default Marquee;
